<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <play-list />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import PlayList from "./components/PlayList";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    PlayList,
    // ProjectsTable,
  },
};
</script>
